/**
 * Project panel
 *
 * Created by stefensuhat on 14/08/18 9.43 AM
 */

import { api } from 'utils/index';

const defaultState = {
    saved: false,
    deleted: false,
    items: [],
    meta: {
        total: 0,
        per_page: 0,
        current_page: 0,
    },
    errors: null,
};

export default {
    name: 'banner',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        saveLoading: state => ({ ...state, errors: null }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors, saved: false };
            }
            return ({ ...state, saved: true, errors: null });
        },
    },
    effects: {
        async fetch(params) {
            await api.get('banners', params)
                .then(response => this.fetchResponse(response));
        },

        async save(data) {
            this.saveLoading();

            const id = data.get('id');
            const url = id ? `banners/${id}` : 'banners';

            await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => this.saveResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, state => state.banner, banner => banner.items);
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (banners, selectedId) => banners.find(banner => banner.id === selectedId),
            );
        },
    }),
};
